module.exports = __webpack_public_path__ + "../resources/img/@temp_news_photo_03.2f0a0cf2.jpg";